import { render, staticRenderFns } from "./ParamCreate.vue?vue&type=template&id=dedaede2&scoped=true&"
import script from "./ParamCreate.vue?vue&type=script&lang=js&"
export * from "./ParamCreate.vue?vue&type=script&lang=js&"
import style0 from "./ParamCreate.vue?vue&type=style&index=0&id=dedaede2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dedaede2",
  null
  
)

export default component.exports